import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './footer.css';
import classNames from "classnames";


class Footer extends Component {

    render() {
        return (
            <div className={classNames({
                'Footer': true,
                'Footer--absolute': this.props.absolute,
            })

            }>
                <a
                    href={'https://www.aitom.cz'}
                    className='Footer__text'
                >
                    {'© AITOM Digital'}
                </a>
            </div>
        );
    }
}

Footer.propTypes = {
    absolute: PropTypes.bool,
}


export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/index.js